import type { CreateSupportTicketDto } from '@repo/api';

/** Nome del campo multipart atteso dal backend per i file. */
export const SUPPORT_TICKET_ATTACHMENTS_FIELD = 'attachments';

/**
 * Traduce il DTO di apertura ticket nel multipart accettato dal backend.
 *
 * Funzione pura (nessuna chiamata di rete) per poter verificare in test il
 * contratto del body: nomi dei campi, omissione degli opzionali vuoti e
 * serializzazione del contesto diagnostico, che viaggia come stringa JSON
 * perché `multipart/form-data` non trasporta oggetti annidati.
 */
export const buildSupportTicketFormData = (
  data: CreateSupportTicketDto,
  files: File[] = []
): FormData => {
  const formData = new FormData();

  formData.append('subject', data.subject);
  formData.append('description', data.description);
  formData.append('type', data.type);
  formData.append('category', data.category);
  formData.append('contactEmail', data.contactEmail);

  if (data.contactName) formData.append('contactName', data.contactName);
  if (data.contactPhone) formData.append('contactPhone', data.contactPhone);
  if (data.diagnosticContext) {
    formData.append(
      'diagnosticContext',
      JSON.stringify(data.diagnosticContext)
    );
  }

  files.forEach((file) =>
    formData.append(SUPPORT_TICKET_ATTACHMENTS_FIELD, file)
  );

  return formData;
};

/**
 * Traduce una risposta del cliente nel multipart accettato da
 * `POST /:id/messages`.
 *
 * Il corpo viaggia **trimmato**: uno spazio in fondo non è un messaggio, e il
 * backend rifiuta i corpi vuoti (`EMPTY_MESSAGE`). `isInternal` non compare
 * affatto — il backend lo forza comunque a `false` lato cliente, e mandarlo
 * suggerirebbe che il cliente possa scrivere note interne.
 */
export const buildSupportTicketMessageFormData = (
  body: string,
  files: File[] = []
): FormData => {
  const formData = new FormData();

  formData.append('body', body.trim());

  files.forEach((file) =>
    formData.append(SUPPORT_TICKET_ATTACHMENTS_FIELD, file)
  );

  return formData;
};
